import React, { useMemo, useRef, useState, useEffect } from 'react';
import i18n from '../../i18n';
import { translationService } from '../../services/translationService';

function LanguagePicker() {
    const params = new URLSearchParams(window.location.search);
    const currentCountryId = params.get('countryId');

    const activeId = useMemo(() => {
        if (currentCountryId === '1' || currentCountryId === '9') return currentCountryId;
        // Fallback based on i18n language
        return i18n.language || i18n.language.startsWith('sv') ? '9' : '1';
    }, [currentCountryId]);

    const setLanguage = (countryId, lang) => {
        const newParams = new URLSearchParams(window.location.search);
        newParams.set('countryId', String(countryId));
        const newUrl = `${window.location.pathname}?${newParams.toString()}`;
        // Update i18n immediately for instant feedback
        translationService.fetchTranslations(lang);
        i18n.changeLanguage(lang);
        // Hard reload so i18n backend using countryId re-initializes consistently
        window.location.assign(newUrl);
    };
    const [open, setOpen] = useState(false);
    const dropdownRef = useRef(null);

    useEffect(() => {
        function handleClickOutside(event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setOpen(false);
            }
        }
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const labelStyles = {
        color: '#666',
        fontSize: '14px',
        marginRight: 8
    };

    const wrapperStyles = {
        display: 'flex',
        alignItems: 'center',
        position: 'relative'
    };

    const headerStyles = {
        padding: '10px 14px',
        border: '1px solid #ddd',
        borderRadius: '8px',
        background: '#fff',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        minWidth: '160px',
        height: '40px',
        boxSizing: 'border-box',
        fontFamily: 'inherit',
        textAlign: 'left',
        width: '100%'
    };

    const optionsStyles = {
        position: 'absolute',
        top: 'calc(100% + 6px)',
        right: 0,
        background: '#fff',
        border: '1px solid #ddd',
        borderRadius: '8px',
        boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
        zIndex: 1000,
        overflow: 'hidden',
        '&:hover': {
            backgroundColor: '#4444'
        }
    };

    const optionRow = {
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
        padding: '10px 14px',
        cursor: 'pointer',
        whiteSpace: 'nowrap',
        width: '130px',
        border: 'none',
        background: 'transparent',
        fontFamily: 'inherit',
        fontSize: 'inherit',
        color: 'inherit',
        textAlign: 'left'
    };

    const caretStyles = { marginLeft: 'auto', color: '#666', fontSize: '0.9rem' };

    const flagStyles = { width: 20, height: 15, borderRadius: 2 };

    const activeFlagCode = activeId === '1' ? 'se' : 'gb';
    const activeLabel = activeId === '1' ? 'Svenska' : 'English';

    return (
        <div style={wrapperStyles} ref={dropdownRef}>
            <span style={labelStyles}>Language</span>
            <button
                type="button"
                className="custom-language-select-header"
                style={headerStyles}
                onClick={() => setOpen(!open)}
                aria-expanded={open}
                aria-controls="language-options"
                aria-haspopup="true"
            >
                <span className={`fi fi-${activeFlagCode}`} style={flagStyles}></span>
                <span>{activeLabel}</span>
                <span style={caretStyles}>▼</span>
            </button>
            {open && (
                <div id="language-options" style={optionsStyles} aria-label="Language options">
                    <button
                        type="button"
                        className="custom-language-select-option"
                        style={optionRow}
                        onClick={() => setLanguage(9, 'en')}
                    >
                        <span className="fi fi-gb" style={flagStyles}></span>
                        <span>English</span>
                    </button>
                    <button
                        type="button"
                        className="custom-language-select-option"
                        style={optionRow}
                        onClick={() => setLanguage(1, 'sv')}
                    >
                        <span className="fi fi-se" style={flagStyles}></span>
                        <span>Svenska</span>
                    </button>
                </div>
            )}
        </div>
    );
}

export default LanguagePicker;


